import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Front from './Front';

if (typeof window !== 'undefined') {
  window.onerror = function (message, source, lineno, colno, error) {
    console.warn('Global error caught:', message, source, lineno, colno, error);

    // If it's "Script error." from LastPass, suppress it
    if (message === 'Script error.') {
      return true; // Suppress the error
    }

    return false; // Let other errors propagate
  };
}

let el = document.getElementById('root') as HTMLElement;
el.classList.add('default')
const root = ReactDOM.createRoot(
  el
);
root.render(
  <React.StrictMode>
    <Front />
  </React.StrictMode>
);